<template>
  <CommonLayout header="ManagementHeader" footer="ManagementFooter">
    <div class="container" :style="'font-size:12px;' + (sortPhase !== 'materialSort' ? 'max-width:3420px;' : '')">
      <div id="search-list" class="row base-color mt-3 py-4">
        <b-overlay :show="overlayShow" rounded="sm" style="width: 100%;">
          <div class="row col-12">
            <div class="col-4 text-left d-block">
              <b-button variant="primary" @click="pageBack()">戻る</b-button>
              <span style="padding-left:20px; font-size: 1.5rem; vertical-align: middle;" v-if="sortPhase === 'materialSort'">納品日振分</span>
              <span style="padding-left:20px; font-size: 1.5rem; vertical-align: middle;" v-else>発注先・計上部署振分</span>
            </div>
            <div class="col-4 text-left" style="margin: auto;" v-if="sortPhase !== 'materialSort'">
              <div>
                {{seikaShiireKbn ? '計上部署CDへの振分数量の合計' : '発注数量'}}が切上数量に満たない場合：<span style="color:red">赤色</span>
              </div>
              <div>
                {{seikaShiireKbn ? '計上部署CDへの振分数量' : '発注数量'}}がロット単位になっていない場合：<span style="background:yellow">黄色（発注不可）</span>
              </div>
            </div>
            <div class="col-4 text-left" v-if="sortPhase !== 'materialSort'">
              <div class="row col-12">
                <div class="text-left main-color info_cell" style="color: #FFF; width: 29%; padding-left: 15px;">
                  PQ
                </div>
                <div class="col-4 text-right info_cell">
                  {{toComma(info_PQ)}}
                </div>
                <div class="col-4 text-right info_cell">
                </div>
              </div>
              <div class="row col-12">
                <div class="text-left main-color info_cell" style="color: #FFF; width: 29%; padding-left: 15px;">
                  NET
                </div>
                <div class="col-4 text-right info_cell">
                  {{toComma(info_NET)}}
                </div>
                <div class="col-4 text-right info_cell">
                </div>
              </div>
              <div class="row col-12">
                <div class="text-left main-color info_cell" style="color: #FFF; width: 29%; padding-left: 15px;">
                  VPQ
                </div>
                <div class="col-4 text-right info_cell">
                  {{toComma(info_VPQ)}}
                </div>
                <div class="col-4 text-right info_cell">
                  ({{info_NET == 0 ? ' - ' : Math.round(info_VPQ / info_NET * 1000) / 10}}%)
                </div>
              </div>
              <div class="row col-12">
                <div class="text-left main-color info_cell" style="color: #FFF; width: 29%; padding-left: 15px;">
                  資器材VPQ
                </div>
                <div class="col-4 text-right info_cell">
                  {{toComma(info_shikizai_VPQ)}}
                </div>
                <div class="col-4 text-right info_cell">
                  ({{info_NET == 0 ? ' - ' : Math.round(info_shikizai_VPQ / info_NET * 1000) / 10}}%)
                </div>
              </div>
              <div class="row col-12">
                <div class="text-left main-color info_cell" style="color: #FFF; width: 29%; padding-left: 15px;">
                  生花VPQ
                </div>
                <div class="col-4 text-right info_cell">
                  {{toComma(info_seika_VPQ)}}
                </div>
                <div class="col-4 text-right info_cell">
                  ({{info_NET == 0 ? ' - ' : Math.round(info_seika_VPQ / info_NET * 1000) / 10}}%)
                </div>
              </div>
              <div class="row col-12" style="font-weight: bold;">
                <div class="text-left main-color info_cell_2" style="color: #FFF; width: 29%; padding-left: 15px;">
                  発注VPQ
                </div>
                <div class="col-4 text-right info_cell_2">
                  {{toComma(info_hachu_VPQ)}}
                </div>
                <div class="col-4 text-right info_cell_2">
                  ({{info_NET == 0 ? ' - ' : Math.round(info_hachu_VPQ / info_NET * 1000) / 10}}%)
                </div>
              </div>
            </div>
          </div>
          <div class="row col-12" v-if="sortPhase === 'materialSort'">
            <label class="col-12 text-left d-block" style="margin-top: 10px;margin-bottom: 0px;">納品日(一括入力用)</label>
            <div class="col-6 pr-0">
              <input id="input-change" class="input" type="date" @change="setWeekDay('-change')"><span :id="'td-change'"></span>
              <b-button class="main-color button-disabled ml-2" :disabled="!dataShow" @click="changeDate()">選択行の納品日を変更</b-button>
            </div>
            <div class="col-6 pr-0 text-right">
              <b-button variant="primary" class="button-disabled" @click="sortProjects" :disabled="!dataShow">納品日ごとに集計</b-button>
            </div>
          </div>
          <div class="col-sm-12 mt-3" style="white-space: nowrap;">
            <b-table-simple hover bordered v-if="sortPhase === 'materialSort'">
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle">
                  <th class="align-middle text-center" style="width: 2%;height: 50px;"><input type="checkbox" class="day-check" @change="allCheck()"></th>
                  <th class="align-middle text-center" style="width: 20%;">商材名</th>
                  <th class="align-middle text-center" style="width: 14%;">色</th>
                  <th class="align-middle text-center" style="width: 7%;">品目</th>
                  <th class="align-middle text-center" style="width: 7%;">品種</th>
                  <th class="align-middle text-center" style="width: 7%;">規格</th>
                  <th class="align-middle text-center" style="width: 7%;">数量</th>
                  <th class="align-middle text-center" style="width: 8%;">用途</th>
                  <th class="align-middle text-center" style="width: 8%;">{{seikaShiireKbn ? '計上部署CD' : '制作拠点CD'}}</th>
                  <th class="align-middle text-center" style="width: 10%;">挙式日</th>
                  <th class="align-middle text-center" style="width: 18%;">納品日</th>
                </tr>
              </thead>
              <b-tbody v-if="dataShow">
                <template v-for="(material, index) in materials">
                  <b-tr :key="index + 'material'">
                    <b-td class="align-middle"><input type="checkbox" class="day-check" :id="'check' + index"></b-td>
                    <b-td class="align-middle">{{material['商材名']}}</b-td>
                    <b-td class="align-middle">{{material['色']}}</b-td>
                    <b-td class="align-middle">{{material['品目']}}</b-td>
                    <b-td class="align-middle">{{material['品種']}}</b-td>
                    <b-td class="align-middle">{{material['規格']}}</b-td>
                    <b-td class="align-middle text-right">{{material['数量']}}</b-td>
                    <b-td class="align-middle">{{yotoName(material['用途コード'])}}</b-td>
                    <b-td class="align-middle">{{material['計上部署コード']}}</b-td>
                    <b-td class="align-middle">{{formatDate(material['施工日'])}}</b-td>
                    <b-td class="align-middle"><input :id="'input' + index" class="input" type="date" :value="Object.keys(material).indexOf('納品日') !== -1 ? material['納品日'] : defaultDate" @change="setWeekDay(index)"><span :id="'td' + index">{{getDefaultWeekDay(material)}}</span></b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>

            <b-table-simple class="left-bottom-none" hover bordered id="data-create-table" v-if="sortPhase === 'dataCreate'">
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle">
                  <th rowspan="2" class="align-middle text-center" style="left:0px; z-index: 3;" >No&emsp;</th>
                  <th rowspan="2" class="align-middle text-center" style="left:39px; z-index: 3;" >&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;商材名&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</th>
                  <th rowspan="2" class="align-middle text-center">色</th>
                  <th rowspan="2" class="align-middle text-center">品目</th>
                  <th rowspan="2" class="align-middle text-center">品種</th>
                  <th rowspan="2" class="align-middle text-center">規格</th>
                  <th rowspan="2" class="align-middle text-center">設定<br>数量</th>
                  <th rowspan="2" class="align-middle text-center">ロット</th>
                  <th rowspan="2" class="align-middle text-center">切上<br>数量</th>
                  <th rowspan="2" class="align-middle text-center">商材<br>単価</th>
                  <th rowspan="2" class="align-middle text-center">用途</th>
                  <th rowspan="2" class="align-middle text-center">納品日</th>
                  <th rowspan="2" class="align-middle text-center" @click="selectAll(true)">フレネット</th>
                  <th rowspan="2" class="align-middle text-center" @click="selectAll(false)">フレネット<br>以外</th>
                  <th rowspan="2" class="align-middle text-center">ロット<br>割れ</th>
                  <th rowspan="1" :colspan="keizyoBusyoCDs.length" class="align-middle text-center">{{seikaShiireKbn ? '計上部署CD' : '発注数量'}}</th>
                </tr>
                <tr>
                  <template v-for="(keizyoBusyoCD, index0) in keizyoBusyoCDs">
                    <th :key="index + 'keizyoBusyoCD' + index0" class="align-middle text-center" style="top:19px;">{{keizyoBusyoCD}}</th>
                  </template>
                </tr>
              </thead>
              <b-tbody v-if="dataShow">
                <template v-for="(material, index) in materials">
                  <b-tr :key="index + 'material'" :id="index + 'material'">
                    <b-td class="align-middle content" style="position: sticky; left:0px; z-index: 2; background: white;">{{index + 1}}</b-td>
                    <b-td v-if="material['週報フラグ'] === '1'" class="align-middle content" style="position: sticky; left:39px; z-index: 2; background: white; white-space: pre-wrap;">{{viewShozaiName(material['商材名'])}}</b-td>
                    <b-td v-else class="align-middle content" style="position: sticky; left:39px; z-index: 2; background: white; white-space: pre-wrap; color: red;">{{viewShozaiName(material['商材名'])}}</b-td>
                    <b-td class="align-middle content">{{material['色']}}</b-td>
                    <b-td class="align-middle content">{{material['品目']}}</b-td>
                    <b-td class="align-middle content">{{material['品種']}}</b-td>
                    <b-td class="align-middle content">{{material['規格']}}</b-td>
                    <b-td class="align-middle content text-right">{{material['数量']}}</b-td>
                    <b-td class="align-middle content text-right">{{material['ロット数']}}</b-td>
                    <b-td class="align-middle content text-right">{{material['発注ロット数量']}}</b-td>
                    <b-td class="align-middle content text-right">{{'¥' + toComma(material['単価'])}}</b-td>
                    <b-td class="align-middle content">{{yotoName(material['用途コード'])}}</b-td>
                    <b-td class="align-middle content">{{formatDate(material['納品日'])}}</b-td>
                    <b-td class="align-middle text-center" @click="objChecked('radio1-' + index)"><input type="radio" class="csv-radio" value="frenet" :id="'radio1-' + index" @change="handleRadio(index, '1')" checked></b-td>
                    <b-td class="align-middle text-center" @click="objChecked('radio2-' + index)"><input type="radio" class="csv-radio" value="not-frenet" :id="'radio2-' + index" @change="handleRadio(index, '2')" ></b-td>
                    <b-td class="align-middle content text-right">{{parseFloat(Math.round(materials[index]['入力数量'] * 100 - materials[index]['数量'] * 100)/100)}}</b-td>
                    <template v-for="(keizyoBusyoCD, index2) in keizyoBusyoCDs">
                      <b-td :key="index + 'keizyoBusyoCD' + index2" class="align-middle content" style="text-align: center;">
                        <input type="number" class="text-right" :style="'width:50px;' + (Number(material['入力数量']) < Number(material['発注ロット数量']) ? 'color:red;' : 'color:black;') + ((Math.round(Number(material[keizyoBusyoCD]) * 100) % Math.round(Number(material['ロット数']) * 100) === 0) ? 'background:white;' : 'background:yellow;')" :name="'quantity-' + index" v-model="materials[index][keizyoBusyoCD]" @change="changeQuantity(index, keizyoBusyoCD)" />
                      </b-td>
                    </template>
                  </b-tr>
                </template>
                <b-tr class="hover-no-color" id="button-tr">
                  <b-td colspan="12" class="left-bottom-none"></b-td>
                  <b-td class="align-middle text-center"><b-button class="main-color csv-bottom" id="button-csv-frenet" @click="CSVForFrenetCheckModal()">発注</b-button></b-td>
                  <b-td class="align-middle text-center"><b-button class="main-color csv-bottom" style="padding:0%" id="button-csv-others" @click="CSVForOthersCheckModal()">発注書出力</b-button></b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
          <div class="row col-12">
            <div class="col-8">
              <b-button variant="primary" @click="pageBack()">戻る</b-button>
            </div>
            <div class="col-4 pr-0 text-right" v-if="sortPhase === 'materialSort'">
              <b-button variant="primary" class="button-disabled" @click="sortProjects" :disabled="!dataShow">納品日ごとに集計</b-button>
            </div>
            <div class="col-4 text-left" v-if="sortPhase !== 'materialSort'">
              <div class="row col-12" style="font-weight: bold; font-size: large;">
                <div class="text-left main-color info_cell" style="color: #FFF; width: 29%; padding-left: 15px;">
                  発注VPQ
                </div>
                <div class="col-4 text-right info_cell">
                  {{toComma(info_hachu_VPQ)}}
                </div>
                <div class="col-4 text-right info_cell">
                  ({{info_NET == 0 ? ' - ' : Math.round(info_hachu_VPQ / info_NET * 1000) / 10}}%)
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
    <CommonModal ref="commonModal" @confirmOk="pageBack()" />
    <CommonModal ref="commonModalCSVForFrenetAlert" @confirmOk="CSVForFrenetModal()" />
    <CommonModal ref="commonModalCSVForFrenet" @confirmOk="CSVForFrenet()" />
    <CommonModal ref="commonModalCSVForOthersAlert" @confirmOk="CSVForOthers()" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import ProjectAggregationModel from '@/models/ProjectAggregationModel'
import MaterialDetailModel from '@/models/MaterialDetailModel'
import CreateDataCSVModel from '@/models/CreateDataCSVModel'
import OrderNumberingModel from '@/models/OrderNumberingModel'
import Vue from 'vue'
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

export default {
  name: 'ProjectAggregation',
  components: {
    CommonLayout,
    CommonModal
  },
  data () {
    return {
      overlayShow: false,
      materials: [],
      tmpMaterials: [],
      defaultDate: '',
      dataShow: false,
      sortPhase: 'materialSort',
      allChecked: false,
      keizyoBusyoCDs: [],
      seikaShiireKbn: true,
      info_PQ: 0,
      info_NET: 0,
      info_VPQ: 0,
      info_shikizai_VPQ: 0,
      info_seika_VPQ: 0,
      info_hachu_VPQ: 0,
      maxParams: 50
    }
  },
  methods: {
    getSortedProjectMaterials: async function () {
      this.overlayShow = true
      const projects = this.$route.query.projectNumber.split(',')
      let errorIdStr = ''
      for (let i = 0; i < projects.length; i++) {
        let params = {'projectNumber': projects[i]}
        const res = await ProjectAggregationModel.getApi(this.$bvModal, params)
        if (res && res['material'].length !== 0) {
          this.materials = this.materials.concat(res['material'])
        } else if (res) {
          errorIdStr += res['id'] + ' '
        }

        // 案件ごとの金額データ集計
        this.info_PQ += res['item_PQ']
        this.info_NET += res['item_NET']
        this.info_shikizai_VPQ += res['material_sikizai_VPQ']
        this.info_seika_VPQ += res['material_seika_VPQ']
      }
      this.info_VPQ = this.info_shikizai_VPQ + this.info_seika_VPQ

      // 集計データが取得できなかった場合
      if (this.materials.length === 0) {
        this.$refs.commonModal.confirmBox('案件番号 ' + errorIdStr + 'に生花の商材が含まれておりませんでした。生花の商材を含む案件を選択してください。', true)
        return false
      } else if (errorIdStr) {
        this.$refs.commonModal.confirmBox('案件番号 ' + errorIdStr + 'に生花の商材が含まれておりませんでした。問題なければ処理を続行してください。')
      }

      // 生花仕入区分設定
      // 9:社外 でなければtrue
      this.seikaShiireKbn = (this.materials[0]['生花仕入担当区分'] !== '9')

      // 商材マスタとの紐づけ
      let params = {'material': [], 'ProdBaseCode': this.materials[0]['制作拠点コード']}
      const materials = this.materials
      this.materials = []
      for (const material of materials) {
        if (params['material'].indexOf(material['商材コード']) === -1) {
          params['material'].push({'materialCode': material['商材コード']})
        }
      }
      let totalCount = 0
      while (true) {
        let newParams = {'material': [], 'ProdBaseCode': params['ProdBaseCode']}
        for (let j = totalCount; j < params['material'].length; j++) {
          newParams['material'].push(params['material'][j])
          if (newParams['material'].length === this.maxParams) {
            break
          }
        }
        totalCount += newParams['material'].length
        newParams['ProdBaseCode'] = params['ProdBaseCode']
        newParams['material'] = JSON.stringify(newParams['material'])
        const res = await MaterialDetailModel.getApi(this.$bvModal, newParams)
        for (const material of materials) {
          for (const resItem of res['materials']) {
            if (material['商材コード'] === resItem['商材コード']) {
              material['単価'] = resItem['原価']
              material['ロット数'] = resItem['ロット数']
              material['品目'] = resItem['品目']
              material['品種'] = resItem['品種']
              material['週報フラグ'] = resItem['週報フラグ']
            }
          }
        }
        if (totalCount === params['material'].length) {
          break
        }
      }
      this.materials = materials
      console.log(this.materials)

      // 商材名、色、規格、施工日、用途コードごとに集計
      // 用途コードの初期値を設定
      for (const i in this.materials) {
        this.materials[i]['用途コード'] = '03'
        this.materials[i]['優先順位'] = 1
        this.materials[i]['チェックフラグ'] = false
        // ブーケが選択された場合
        if (this.materials[i]['大区分'] === 'ブーケ' && localStorage.getItem('checkBouquet') === '1') {
          this.materials[i]['用途コード'] = '04'
          this.materials[i]['優先順位'] = 2
          this.materials[i]['チェックフラグ'] = true
        }
        if (this.materials[i]['売上大項目'] === '外商') {
          this.materials[i]['用途コード'] = '15'
          this.materials[i]['優先順位'] = 3
          // 外商が選択された場合
          if (localStorage.getItem('checkOutsideCommerce') === '1') {
            this.materials[i]['チェックフラグ'] = true
          } else {
            this.materials[i]['チェックフラグ'] = false
          }
        }
        if (this.materials[i]['売上大項目'] === '社用') {
          this.materials[i]['用途コード'] = '07'
          this.materials[i]['優先順位'] = 4
          // 社用が選択された場合
          if (localStorage.getItem('checkHotelOthers') === '1') {
            this.materials[i]['チェックフラグ'] = true
          } else {
            this.materials[i]['チェックフラグ'] = false
          }
        }
        if (this.materials[i]['明細種別'] === 'その他(売上計上なし)') {
          this.materials[i]['用途コード'] = '14'
          this.materials[i]['優先順位'] = 5
          // 売上外その他が選択された場合
          if (localStorage.getItem('checkNotSalesOthers') === '1') {
            this.materials[i]['チェックフラグ'] = true
          } else {
            this.materials[i]['チェックフラグ'] = false
          }
        }
      }
      // チェック対象ではない花材は「婚礼→ブーケ→外商→ホテルその他→売上外その他」の優先順位で集約する
      const copyMaterials = JSON.parse(JSON.stringify(this.materials))
      for (const i in this.materials) {
        for (const t in copyMaterials) {
          if (this.materials[i]['商材コード'] === copyMaterials[t]['商材コード'] && this.materials[i]['優先順位'] > copyMaterials[t]['優先順位'] && (!this.materials[i]['チェックフラグ'] && !copyMaterials[t]['チェックフラグ'])) {
            this.materials[i]['用途コード'] = copyMaterials[t]['用途コード']
            this.materials[i]['優先順位'] = copyMaterials[t]['優先順位']
          }
        }
      }
      console.log(this.materials)
      let newMaterials = {}
      this.materials.forEach((material) => {
        // 用途コード設定
        let yotoCode = material['用途コード']

        const key = material['品目'] + '_' + material['品種'] + '_' + material['色'] + '_' + material['規格'] + '_' + material['計上部署コード'] + '_' + material['施工日'] + '_' + yotoCode
        if (newMaterials[key] === undefined) {
          newMaterials[key] = material
          newMaterials[key]['用途コード'] = yotoCode
        } else {
          const quantity = (Math.round(Number(newMaterials[key]['数量']) * 100) + Math.round(Number(material['数量']) * 100)) / 100
          newMaterials[key]['数量'] = String(quantity)
        }
      })
      this.materials = []
      for (const material in newMaterials) {
        this.materials.push(newMaterials[material])
      }

      // ソート処理追加
      this.materials.sort(function (a, b) {
        // 品目で並び替え
        if (a['品目'] !== b['品目']) {
          if (isNaN(a['品目']) || isNaN(b['品目'])) {
            if (isNaN(a['品目']) && isNaN(b['品目'])) {
              if (a['品目'] < b['品目']) return -1
              if (a['品目'] > b['品目']) return 1
            } else {
              if (isNaN(a['品目'])) {
                return 1
              } else {
                return -1
              }
            }
          } else {
            if (Number(a['品目']) < Number(b['品目'])) return -1
            if (Number(a['品目']) > Number(b['品目'])) return 1
          }
        }
        // 品種で並び替え
        if (a['品種'] !== b['品種']) {
          if (isNaN(a['品種']) || isNaN(b['品種'])) {
            if (isNaN(a['品種']) && isNaN(b['品種'])) {
              if (a['品種'] < b['品種']) return -1
              if (a['品種'] > b['品種']) return 1
            } else {
              if (isNaN(a['品種'])) {
                return 1
              } else {
                return -1
              }
            }
          } else {
            if (Number(a['品種']) < Number(b['品種'])) return -1
            if (Number(a['品種']) > Number(b['品種'])) return 1
          }
        }
        // 商材名で並び替え
        if (a['商材名'] !== b['商材名']) {
          if (a['商材名'] < b['商材名']) return -1
          if (a['商材名'] > b['商材名']) return 1
        }
        // 施工日で並び替え
        if (a['施工日'] !== b['施工日']) {
          return (a['施工日'] - b['施工日']) * -1
        }
        // 用途コードで並び替え
        if (a['用途コード'] !== b['用途コード']) {
          if (a['用途コード'] < b['用途コード']) return -1
          if (a['用途コード'] > b['用途コード']) return 1
        }
        return 0
      })
      this.tmpMaterials = this.materials
      this.dataShow = true
      this.overlayShow = false
      console.log(this.materials)
    },
    getDefaultDate () {
      let date = new Date()
      let nowDay = date.getDay()

      if (nowDay === 0) {
      // 日曜日の場合
        date.setTime(date.getTime() + (10 * 24 * 3600 * 1000))
      } else if (nowDay === 1) {
      // 月曜日の場合
        date.setTime(date.getTime() + (9 * 24 * 3600 * 1000))
      } else if (nowDay === 2) {
      // 火曜日の場合
        date.setTime(date.getTime() + (8 * 24 * 3600 * 1000))
      } else if (nowDay === 3) {
      // 水曜日の場合
        date.setTime(date.getTime() + (7 * 24 * 3600 * 1000))
      } else if (nowDay === 4) {
      // 木曜日の場合
        date.setTime(date.getTime() + (6 * 24 * 3600 * 1000))
      } else if (nowDay === 5) {
      // 金曜日の場合
        date.setTime(date.getTime() + (5 * 24 * 3600 * 1000))
      } else if (nowDay === 6) {
      // 土曜日の場合
        date.setTime(date.getTime() + (4 * 24 * 3600 * 1000))
      }
      date = this.formatDateForInput(date)
      return date
    },
    formatDateForInput (date) {
      const newDate = new Date(date)
      let format = 'YYYY-MM-DD'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      return format
    },
    getDefaultWeekDay (material) {
      let date = this.getDefaultDate()
      if (Object.keys(material).indexOf('納品日') !== -1) {
        date = material['納品日']
      }
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = '(WW)'
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      return format
    },
    setWeekDay (id) {
      let date = document.getElementById('input' + id)
      date = date.value
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = '(WW)'
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      document.getElementById('td' + id).innerText = format
    },
    formatDate (date) {
      // 日付のフォーマット
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = 'YYYY/MM/DD(WW)'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      return format
    },
    sortProjects: async function () {
      this.overlayShow = true
      this.allChecked = false
      this.dataShow = false
      this.sortPhase = 'dataCreate'
      // 画面入力した納品日反映
      this.materials.forEach((material, index) => {
        const deliverDate = document.getElementById('input' + index).value
        material['納品日'] = deliverDate
      })
      // 納品日の準じた単価、ロットに更新する
      // 商材マスタとの紐づけ
      let params = {'material': [], 'ProdBaseCode': this.materials[0]['制作拠点コード']}
      const materials = this.materials
      this.materials = []
      for (const material of materials) {
        if (params['material'].indexOf(material['商材コード']) === -1) {
          params['material'].push({'materialCode': material['商材コード'], 'deliveryDate': material['納品日']})
        }
      }
      let totalCount = 0
      while (true) {
        let newParams = {'material': [], 'ProdBaseCode': params['ProdBaseCode']}
        for (let j = totalCount; j < params['material'].length; j++) {
          newParams['material'].push(params['material'][j])
          if (newParams['material'].length === this.maxParams) {
            break
          }
        }
        totalCount += newParams['material'].length
        newParams['ProdBaseCode'] = params['ProdBaseCode']
        newParams['material'] = JSON.stringify(newParams['material'])
        const res = await MaterialDetailModel.getApi(this.$bvModal, newParams)
        for (const material of materials) {
          for (const resItem of res['materials']) {
            if (material['商材コード'] === resItem['商材コード']) {
              material['単価'] = resItem['原価']
              material['ロット数'] = resItem['ロット数']
              material['品目'] = resItem['品目']
              material['品種'] = resItem['品種']
              material['週報フラグ'] = resItem['週報フラグ']
            }
          }
        }
        if (totalCount === params['material'].length) {
          break
        }
      }
      this.materials = materials
      console.log(this.materials)

      localStorage.setItem('materials', JSON.stringify(this.materials))
      this.tmpMaterials = this.materials

      this.keizyoBusyoCDs = []
      this.materials.forEach((material) => {
        // 使用している計上部署コードをリストアップする
        if (!this.keizyoBusyoCDs.includes(material['計上部署コード'])) {
          this.keizyoBusyoCDs.push(material['計上部署コード'])
        }
      })

      // 商材名、色、規格、納品日、用途コードごとに集計
      // 用途コードの初期値を設定
      for (const i in this.materials) {
        this.materials[i]['用途コード'] = '03'
        this.materials[i]['優先順位'] = 1
        this.materials[i]['チェックフラグ'] = false
        // ブーケが選択された場合
        if (this.materials[i]['大区分'] === 'ブーケ' && localStorage.getItem('checkBouquet') === '1') {
          this.materials[i]['用途コード'] = '04'
          this.materials[i]['優先順位'] = 2
          this.materials[i]['チェックフラグ'] = true
        }
        if (this.materials[i]['売上大項目'] === '外商') {
          this.materials[i]['用途コード'] = '15'
          this.materials[i]['優先順位'] = 3
          // 外商が選択された場合
          if (localStorage.getItem('checkOutsideCommerce') === '1') {
            this.materials[i]['チェックフラグ'] = true
          } else {
            this.materials[i]['チェックフラグ'] = false
          }
        }
        if (this.materials[i]['売上大項目'] === '社用') {
          this.materials[i]['用途コード'] = '07'
          this.materials[i]['優先順位'] = 4
          // 社用が選択された場合
          if (localStorage.getItem('checkHotelOthers') === '1') {
            this.materials[i]['チェックフラグ'] = true
          } else {
            this.materials[i]['チェックフラグ'] = false
          }
        }
        if (this.materials[i]['明細種別'] === 'その他(売上計上なし)') {
          this.materials[i]['用途コード'] = '14'
          this.materials[i]['優先順位'] = 5
          // 売上外その他が選択された場合
          if (localStorage.getItem('checkNotSalesOthers') === '1') {
            this.materials[i]['チェックフラグ'] = true
          } else {
            this.materials[i]['チェックフラグ'] = false
          }
        }
      }
      // チェック対象ではない花材は「婚礼→ブーケ→外商→ホテルその他→売上外その他」の優先順位で集約する
      const copyMaterials = JSON.parse(JSON.stringify(this.materials))
      for (const i in this.materials) {
        for (const t in copyMaterials) {
          if (this.materials[i]['商材コード'] === copyMaterials[t]['商材コード'] && this.materials[i]['優先順位'] > copyMaterials[t]['優先順位'] && (!this.materials[i]['チェックフラグ'] && !copyMaterials[t]['チェックフラグ'])) {
            this.materials[i]['用途コード'] = copyMaterials[t]['用途コード']
            this.materials[i]['優先順位'] = copyMaterials[t]['優先順位']
          }
        }
      }
      let newMaterials = {}
      this.materials.forEach((material) => {
        // 用途コード設定
        let yotoCode = material['用途コード']

        const key = material['品目'] + '_' + material['品種'] + '_' + material['色'] + '_' + material['規格'] + '_' + material['納品日'] + '_' + yotoCode
        if (newMaterials[key] === undefined) {
          newMaterials[key] = material
          // 計上部署コードを項目名に追加
          for (let j = 0; j < this.keizyoBusyoCDs.length; j++) {
            newMaterials[key][this.keizyoBusyoCDs[j]] = 0
            newMaterials[key][this.keizyoBusyoCDs[j] + '(初期値)'] = 0
          }
          const quantity = Math.round(Number(material['数量']) * 100) / 100
          newMaterials[key]['数量'] = String(quantity)
          newMaterials[key]['入力数量'] = quantity
          newMaterials[key]['ロット割れ'] = 0
          newMaterials[key][material['計上部署コード']] = quantity
          newMaterials[key][material['計上部署コード'] + '(初期値)'] = quantity
        } else {
          // 数量を合算
          const quantity = (Math.round(Number(newMaterials[key]['数量']) * 100) + Math.round(Number(material['数量']) * 100)) / 100
          newMaterials[key]['数量'] = String(quantity)
          newMaterials[key]['入力数量'] = quantity
          // 計上部署コードごとの合算
          const quantityKeizyo = (Math.round(Number(newMaterials[key][material['計上部署コード']]) * 100) + Math.round(Number(material['数量']) * 100)) / 100
          newMaterials[key][material['計上部署コード']] = quantityKeizyo
          newMaterials[key][material['計上部署コード'] + '(初期値)'] = quantityKeizyo
        }
      })
      this.materials = []
      for (const material in newMaterials) {
        this.materials.push(newMaterials[material])
      }
      for (const material in this.materials) {
        let quantityStr = this.materials[material]['数量']
        let lotStr = this.materials[material]['ロット数']
        // 発注ロット数量の算出
        if (!isNaN(quantityStr) && !isNaN(lotStr) && Number(quantityStr) !== 0 && Number(lotStr) !== 0) {
          let quantity = Number(quantityStr)
          let lot = Number(lotStr)
          let buyNum = Math.trunc(quantity / lot)
          if (quantity % lot !== 0) {
            buyNum++
          }
          this.materials[material]['発注ロット数量'] = String(Math.round(buyNum * lot * 100) / 100)
        } else {
          this.materials[material]['発注ロット数量'] = '0'
        }

        // デフォルト値として発注ロット数量を設定
        for (let j = 0; j < this.keizyoBusyoCDs.length; j++) {
          // 入力数量と計上部署の入力値が一致しているとき、他の入力値は自然と0になる
          if (this.materials[material]['入力数量'] === this.materials[material][this.keizyoBusyoCDs[j]]) {
            this.materials[material][this.keizyoBusyoCDs[j]] = Number(this.materials[material]['発注ロット数量'])
            this.materials[material]['入力数量'] = Number(this.materials[material]['発注ロット数量'])
            break
          }
        }
      }

      // 発注VPQ更新
      this.changeHachuVPQ()

      // ソート処理追加
      this.materials.sort(function (a, b) {
        // 品目で並び替え
        if (a['品目'] !== b['品目']) {
          if (isNaN(a['品目']) || isNaN(b['品目'])) {
            if (isNaN(a['品目']) && isNaN(b['品目'])) {
              if (a['品目'] < b['品目']) return -1
              if (a['品目'] > b['品目']) return 1
            } else {
              if (isNaN(a['品目'])) {
                return 1
              } else {
                return -1
              }
            }
          } else {
            if (Number(a['品目']) < Number(b['品目'])) return -1
            if (Number(a['品目']) > Number(b['品目'])) return 1
          }
        }
        // 品種で並び替え
        if (a['品種'] !== b['品種']) {
          if (isNaN(a['品種']) || isNaN(b['品種'])) {
            if (isNaN(a['品種']) && isNaN(b['品種'])) {
              if (a['品種'] < b['品種']) return -1
              if (a['品種'] > b['品種']) return 1
            } else {
              if (isNaN(a['品種'])) {
                return 1
              } else {
                return -1
              }
            }
          } else {
            if (Number(a['品種']) < Number(b['品種'])) return -1
            if (Number(a['品種']) > Number(b['品種'])) return 1
          }
        }
        // 商材名で並び替え
        if (a['商材名'] !== b['商材名']) {
          if (a['商材名'] < b['商材名']) return -1
          if (a['商材名'] > b['商材名']) return 1
        }
        // 納品日で並び替え
        if (a['納品日'] !== b['納品日']) {
          return (a['納品日'] - b['納品日']) * -1
        }
        // 用途コードで並び替え
        if (a['用途コード'] !== b['用途コード']) {
          if (a['用途コード'] < b['用途コード']) return -1
          if (a['用途コード'] > b['用途コード']) return 1
        }
        return 0
      })
      this.dataShow = true
      this.overlayShow = false
    },
    handleRadio (id, radioNum) {
      if (radioNum === '1') {
        document.getElementById('radio2-' + id).checked = false
      } else if (radioNum === '2') {
        document.getElementById('radio1-' + id).checked = false
      }
    },
    objChecked (id) {
      let idObj = document.getElementById(id)
      if (idObj !== null) {
        idObj.click()
      }
    },
    CSVForFrenetCheckModal: async function () {
      let checkflg = false
      let alertflg = false

      // ラジオボタンチェック
      let tbody = document.getElementsByTagName('tbody')
      let tr = tbody['0'].getElementsByTagName('tr')
      tr = Array.prototype.filter.call(tr, e => e.id !== 'button-tr')
      for (let i = 0; i < tr.length; i++) {
        const isChecked = document.getElementById('radio1-' + i).checked
        if (isChecked) {
          // ラジオボタンが選択されている情報に対してチェックを行う
          var lotCheckflg = true
          var keizyoBusyoCD = ''
          var lotNum = Number(this.materials[i]['ロット数'])
          for (var j = 0; j < this.keizyoBusyoCDs.length; j++) {
            keizyoBusyoCD = this.keizyoBusyoCDs[j]
            var busyoNum = Number(this.materials[i][keizyoBusyoCD])
            if (Math.round(busyoNum * 100) % Math.round(lotNum * 100) !== 0) {
              lotCheckflg = false
              break
            }
          }
          if (!lotCheckflg) {
            this.$bvModal.msgBoxOk('' + (i + 1) + '行目、' + keizyoBusyoCD + 'の入力値がロット単位ではありません。')
            this.overlayShow = false
            return false
          }

          // 発注数量と合計数量
          if (Math.round(Number(this.materials[i]['発注ロット数量']) * 100) > Math.round(Number(this.materials[i]['入力数量']) * 100)) {
            alertflg = true
          }

          checkflg = true
        }
      }
      if (!checkflg) {
        this.$bvModal.msgBoxOk('フレネットは選択されていません。')
        this.overlayShow = false
        return false
      }

      // アラート
      if (alertflg) {
        this.$refs.commonModalCSVForFrenetAlert.confirmBoxOkCancel(this.consts.csvForFrenetMsg.alert)
      } else {
        this.CSVForFrenetModal()
      }
    },
    CSVForFrenetModal: async function () {
      this.$refs.commonModalCSVForFrenet.confirmBoxOkCancel(this.consts.csvForFrenetMsg.question)
    },
    CSVForFrenet: async function () {
      this.overlayShow = true
      let params = {'isForFrenet': true, 'items': {}, 'projectNumbers': this.$route.query.projectNumber.split(',').reverse()}
      let tbody = document.getElementsByTagName('tbody')
      let tr = tbody['0'].getElementsByTagName('tr')
      tr = Array.prototype.filter.call(tr, e => e.id !== 'button-tr')
      for (let i = 0; i < tr.length; i++) {
        const isChecked = document.getElementById('radio1-' + i).checked
        if (isChecked) {
          for (let j = 0; j < this.keizyoBusyoCDs.length; j++) {
            let paramItem = JSON.parse(JSON.stringify(this.materials[i]))
            paramItem['顧客コード'] = this.keizyoBusyoCDs[j]
            paramItem['受注量'] = this.materials[i][this.keizyoBusyoCDs[j]]
            let paramKey = '' + i + '-' + j
            if (Number(paramItem['受注量']) !== 0) {
              params['items'][paramKey] = paramItem
            }
          }
        }
      }
      params['isForFrenet'] = true
      let result = await OrderNumberingModel.postApi(this.$bvModal, params)
      params['orderNumber'] = result['orderNumber']
      params['fileName'] = result['fileName']
      CreateDataCSVModel.postApi(this.$bvModal, params, (res) => {
        const fileName = res.data.fileName
        // CSV出力
        // let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        // let blob = new Blob([bom, res.data.content], {type: res.headers['content-type']})
        // SaveCSV(blob, fileName)
        console.log(fileName)
        this.$refs.commonModalCSVForFrenet.confirmBox(this.consts.csvForFrenetMsg.execution, null, 'OK')
      })
      this.overlayShow = false

      // 非活性処理
      document.getElementById('button-csv-frenet').disabled = true
      for (let i = 0; i < tr.length; i++) {
        let isRadio1 = document.getElementById('radio1-' + i)
        if (isRadio1) {
          isRadio1.disabled = true
          const isRadio1Checked = isRadio1.checked
          let isRadio2 = document.getElementById('radio2-' + i)
          if (isRadio2 && isRadio1Checked) {
            isRadio2.disabled = true

            // 計上部署の入力欄の非活性化
            const inputQuantities = document.getElementsByName('quantity-' + i)
            if (inputQuantities.length > 0) {
              for (let j = 0; j < inputQuantities.length; j++) {
                inputQuantities[j].disabled = true
              }
            }
          }
        }
      }
    },
    CSVForOthersCheckModal: async function () {
      let checkflg = false
      let alertflg = false

      // ラジオボタンチェック
      let tbody = document.getElementsByTagName('tbody')
      let tr = tbody['0'].getElementsByTagName('tr')
      tr = Array.prototype.filter.call(tr, e => e.id !== 'button-tr')
      for (let i = 0; i < tr.length; i++) {
        const isChecked = document.getElementById('radio2-' + i).checked
        if (isChecked) {
          // ラジオボタンが選択されている情報に対してチェックを行う
          // 発注数量と合計数量
          if (Math.round(Number(this.materials[i]['発注ロット数量']) * 100) > Math.round(Number(this.materials[i]['入力数量']) * 100)) {
            alertflg = true
          }

          checkflg = true
        }
      }
      if (!checkflg) {
        this.$bvModal.msgBoxOk('フレネット以外は選択されていません。')
        this.overlayShow = false
        return false
      }

      // アラート
      if (alertflg) {
        this.$refs.commonModalCSVForOthersAlert.confirmBoxOkCancel(this.consts.csvForOthersMsg.alert)
      } else {
        this.CSVForOthers()
      }
    },
    CSVForOthers: async function () {
      this.overlayShow = true
      let tbody = document.getElementsByTagName('tbody')
      let params = {'isForFrenet': false, 'items': {}, 'projectNumbers': this.$route.query.projectNumber.split(',').reverse()}
      let tr = tbody['0'].getElementsByTagName('tr')
      tr = Array.prototype.filter.call(tr, e => e.id !== 'button-tr')
      for (let i = 0; i < tr.length; i++) {
        const isChecked = document.getElementById('radio2-' + i).checked
        if (isChecked) {
          params['items'][i] = this.materials[i]
          params['items'][i]['受注量'] = 0
          for (let j = 0; j < this.keizyoBusyoCDs.length; j++) {
            params['items'][i]['受注量'] += Number(this.materials[i][this.keizyoBusyoCDs[j]])
          }
        }
      }

      params['isForFrenet'] = false
      let result = await OrderNumberingModel.postApi(this.$bvModal, params)
      params['orderNumber'] = result['orderNumber']
      params['fileName'] = result['fileName']
      CreateDataCSVModel.postApi(this.$bvModal, params, (res) => {
        window.open(res.data.items.filePath, '_blank')
      })
      this.overlayShow = false

      // 非活性処理
      document.getElementById('button-csv-others').disabled = true
      for (let i = 0; i < tr.length; i++) {
        let isRadio2 = document.getElementById('radio2-' + i)
        if (isRadio2) {
          isRadio2.disabled = true
          const isRadio2Checked = isRadio2.checked
          let isRadio1 = document.getElementById('radio1-' + i)
          if (isRadio1 && isRadio2Checked) {
            isRadio1.disabled = true

            // 計上部署の入力欄の非活性化
            const inputQuantities = document.getElementsByName('quantity-' + i)
            if (inputQuantities.length > 0) {
              for (let j = 0; j < inputQuantities.length; j++) {
                inputQuantities[j].disabled = true
              }
            }
          }
        }
      }
    },
    selectAll (isFrenet) {
      if (isFrenet) {
        for (let i = 0; i < this.materials.length; i++) {
          let isRadio1 = document.getElementById('radio1-' + i)
          let isRadio2 = document.getElementById('radio2-' + i)
          if (!isRadio1.disabled && !isRadio2.disabled) {
            isRadio1.checked = true
            isRadio2.checked = false
          }
        }
      } else {
        for (let i = 0; i < this.materials.length; i++) {
          let isRadio1 = document.getElementById('radio1-' + i)
          let isRadio2 = document.getElementById('radio2-' + i)
          if (!isRadio1.disabled && !isRadio2.disabled) {
            isRadio1.checked = false
            isRadio2.checked = true
          }
        }
      }
    },
    toComma (num) {
      num = String(num)
      if ((num).trim().length !== 0 && !isNaN(num)) {
        let newNum = Number(num).toLocaleString()
        return newNum
      }
      return num
    },
    pageBack () {
      if (this.sortPhase === 'materialSort') {
        localStorage.setItem('isPageBack', JSON.stringify(true))
        const targetPath = '/project_list?list_type=dataList'
        this.$router.push(targetPath)
      } else if (this.sortPhase === 'dataCreate') {
        this.overlayShow = true
        this.materials = []
        this.sortPhase = 'materialSort'
        setTimeout(() => {
          this.materials = JSON.parse(localStorage.getItem('materials'))
          this.overlayShow = false
        }, 500)
      }
    },
    allCheck () {
      if (this.allChecked === true) {
        for (let i = 0; i < this.materials.length; i++) {
          document.getElementById('check' + i).checked = false
        }
        this.allChecked = false
      } else {
        for (let i = 0; i < this.materials.length; i++) {
          document.getElementById('check' + i).checked = true
        }
        this.allChecked = true
      }
    },
    changeDate () {
      const date = document.getElementById('input-change').value
      if (date !== '') {
        for (let i = 0; i < this.materials.length; i++) {
          if (document.getElementById('check' + i).checked === true) {
            document.getElementById('input' + i).value = date
            this.setWeekDay(i)
          }
        }
      }
    },
    yotoName (yotoCode) {
      var res = ''
      if (yotoCode === '03') {
        res = '婚礼'
      } else if (yotoCode === '04') {
        res = 'ブーケ'
      } else if (yotoCode === '15') {
        res = '外商'
      } else if (yotoCode === '07') {
        res = 'ホテルその他'
      } else if (yotoCode === '14') {
        res = '売上外その他'
      }
      return res
    },
    viewShozaiName (shozaiName) {
      var res = ''
      var resSub = ''
      // 文字列の幅取得
      const ctx = document.createElement('canvas').getContext('2d')
      ctx.font = '12px "Segoe UI"'
      // 200を超えたら改行を追加する
      for (var i = 0; i < shozaiName.length; i++) {
        resSub += shozaiName[i]
        if (ctx.measureText(resSub).width >= 170) {
          resSub += '\n'
          res += resSub
          resSub = ''
        }
      }
      res += resSub
      return res
    },
    changeHachuVPQ () {
      this.info_hachu_VPQ = 0
      for (var i = 0; i < this.materials.length; i++) {
        let tanka = this.materials[i]['単価'] ? Number(this.materials[i]['単価']) : 0
        let inpNum = this.materials[i]['入力数量'] ? Number(this.materials[i]['入力数量']) : 0
        // 発注VPQに単価×発注ロット数量を加算
        this.info_hachu_VPQ += tanka * inpNum
      }
    },
    changeQuantity (index, keizyoBusyoCD) {
      this.overlayShow = true
      let lotNum = this.materials[index]['ロット数']
      let lotUpNum = this.materials[index]['発注ロット数量']

      // 入力値を整える
      if (!(new RegExp(/^([1-9]\d*|0)(\.\d{1,2})?$/).test(this.materials[index][keizyoBusyoCD]))) {
        this.$set(this.materials[index], keizyoBusyoCD, 0)
      }

      const inputQuantities = document.getElementsByName('quantity-' + index)
      if (inputQuantities.length > 0) {
        var sum = 0
        for (var i = 0; i < inputQuantities.length; i++) {
          // 数値のみ抜き出す
          let inputNum = 0
          if (new RegExp(/^([1-9]\d*|0)(\.\d{1,2})?$/).test(inputQuantities[i].value)) {
            inputNum = Number(inputQuantities[i].value)
          }
          sum += inputNum
          if (Math.round(inputNum * 100) % Math.round(lotNum * 100) !== 0) {
            inputQuantities[i].style.background = 'yellow'
          } else {
            inputQuantities[i].style.background = 'white'
          }
        }
        this.$set(this.materials[index], '入力数量', sum)
        if (sum < Number(lotUpNum)) {
          for (i = 0; i < inputQuantities.length; i++) {
            inputQuantities[i].style.color = 'red'
          }
        } else {
          for (i = 0; i < inputQuantities.length; i++) {
            inputQuantities[i].style.color = 'black'
          }
        }
        this.$set(this.materials[index], 'ロット割れ', '' + (sum - Number(this.materials[index]['数量'])))

        // 発注VPQ更新
        this.changeHachuVPQ()
      }
      this.overlayShow = false
    }
  },
  computed: {
  },
  mounted () {
    this.getSortedProjectMaterials()
    this.defaultDate = this.getDefaultDate()
  }
}
</script>
<style>
table > thead > tr > th {
  background-color: #CACFEC !important;
  border: 1px solid #dee2e6 !important;
}
.left-bottom-none {
  border-left: none !important;
  border-bottom: none !important;
}
.table-hover tbody tr.hover-no-color:hover {
  color: unset;
  background-color: unset;
}
.button-disabled:disabled {
  background-color: rgb(0, 123, 255);
  color: #fff;
  opacity: 1;
}
.csv-radio {
  margin-top: 5px;
  margin-bottom: 5px;
}
.csv-bottom {
  height: 70px;
  width: 60px;
  white-space: normal;
}
.day-check {
  width:20px;
  height:20px;
  margin-top:3px;
}
.info_cell {
  border:solid 1px;
  margin-top: -1px;
  margin-left: -1px;
  border-color: #000;
}
.info_cell_2 {
  border:solid 1px;
  margin-top: -1px;
  margin-left: -1px;
  border-color: #000;
  border-top: double;
}
table {
  border-collapse: separate;
  border-spacing: 0px;
}
th {
  position: sticky;
  top: 0;
  z-index: 1;
}
th, td {
  padding: 0px 10px !important;
}
input[type = 'radio'] {
  transform: scale(1.5);
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProjectAggregation.vue